module.exports = __webpack_public_path__ + "static/taylor-swift-3507bb6c874abee7d0bae6100c465f2a.jpg";